import { render } from "./LayoutResults.vue?vue&type=template&id=72fe1080"
import script from "./LayoutResults.vue?vue&type=script&lang=js"
export * from "./LayoutResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/quiz/layouts/LayoutResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72fe1080"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72fe1080', __exports__)) {
    api.reload('72fe1080', __exports__)
  }
  
  module.hot.accept("./LayoutResults.vue?vue&type=template&id=72fe1080", () => {
    api.rerender('72fe1080', render)
  })

}


export default __exports__